import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconComponent, IsDefinedNotEmptyPipe, Modal2 } from '@softline/ui-core';
import { ArtikelMenge } from '../../types/artikel-menge';
import { Palette } from '../../types/palette';

@Component({
  selector: 'soft-pallet-item-list-modal',
  templateUrl: './pallet-item-list-modal.component.html',
  styleUrls: ['./pallet-item-list-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [],
  imports: [IconComponent, IsDefinedNotEmptyPipe],
})
export class PalletItemListModalComponent extends Modal2 {
  readonly items = input<ArtikelMenge[]>();
  readonly pallet = input<Palette>();
}
